/**
 * @generated SignedSource<<a518b4ace826b42d3ad7bd2c2136a43d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImportJsonDialogMutation$variables = {
  fallbackDate?: string | null | undefined;
  file: string;
};
export type ImportJsonDialogMutation$data = {
  readonly importTasks: {
    readonly createdCount: number;
  };
};
export type ImportJsonDialogMutation = {
  response: ImportJsonDialogMutation$data;
  variables: ImportJsonDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fallbackDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "file"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "fallbackDate",
        "variableName": "fallbackDate"
      },
      {
        "kind": "Variable",
        "name": "file",
        "variableName": "file"
      }
    ],
    "concreteType": "ImportTasksPayload",
    "kind": "LinkedField",
    "name": "importTasks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportJsonDialogMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ImportJsonDialogMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "de3b7bd2dfa33719ffa3d6a5a88d5aeb",
    "id": null,
    "metadata": {},
    "name": "ImportJsonDialogMutation",
    "operationKind": "mutation",
    "text": "mutation ImportJsonDialogMutation(\n  $file: String!\n  $fallbackDate: String\n) {\n  importTasks(file: $file, fallbackDate: $fallbackDate) {\n    createdCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f9f5acf58e152b7e94f5a3c6a321419";

export default node;
